// src/App.js
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { NavigationProvider } from "./context/NavigationContext";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import { Grow } from '@mui/material';
import { SnackbarProvider } from "notistack";
import MainLayout from "./components/Layout/MainLayout";
import SuperAdminPanel from "./components/SuperAdmin/SuperAdminPanel";
import { theme } from "./theme/theme";

function AppContent() {
  const { user } = useAuth();
  if (['superadmin', 'franquiciado'].includes(user?.role)) return <SuperAdminPanel />;
  return (
    <NavigationProvider>
      <MainLayout />
    </NavigationProvider>
  );
}

function App() {
  return (
    <SnackbarProvider
      maxSnack={3}
      dense
      TransitionComponent={Grow}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      preventDuplicate
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <ProtectedRoute>
            <AppContent />
          </ProtectedRoute>
        </AuthProvider>
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default App;
